import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestFinanceEntryResponse } from "@/types";

async function writeOffFinanceEntry({
  id,
}: {
  id: string;
}): Promise<RequestFinanceEntryResponse> {
  const response = await httpRequest.post<RequestFinanceEntryResponse>(
    `/finance-entries/${id}/pay`
  );
  return response.data;
}

export function useWriteOffFinanceEntryMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: writeOffFinanceEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["finance-entries"] });
    },
  });
}
